<template>
  <div>
    <breadcrumb :list="detailList"></breadcrumb>
    <goodsproduct
      :gooodsDetail="gooodsDetail"
      :goodsType="type"
      v-if="gooodsDetail"
    >
    </goodsproduct>
    <goodsdetailimg
      :gooodsDetail="gooodsDetail"
      :goodsType="type"
      v-if="gooodsDetail"
    ></goodsdetailimg>
    <smActivity ref="smAct"></smActivity>
  </div>
</template>
<script>
import goodsproduct from "./components/goods-product";
import goodsdetailimg from "./components/goods-detail-img";
export default {
  components: { goodsproduct, goodsdetailimg },
  data() {
    return {
      gooodsDetail: "",
      type: "",
      status: "",
      detailList: [],
      detailList1: [
        { name: "首页", path: "/" },
        { name: "商品搜索", path: "/search" },
      ],
      detailList2: [
        { name: "首页", path: "/" },
        { name: "套餐活动", path: "/meal" },
      ],
      detailList3: [
        { name: "首页", path: "/" },
        { name: "限时特价", path: "/bargain" },
      ],
      detailList4: [
        { name: "厂家活动", path: "/activities" },
        { name: "活动详情", path: "/activities" },
      ],
      id: "",
    };
  },
  watch: {
    $route: function (t, f) {
      let { type, goodsId } = t.query;
      if (type == 2) {
        this.detailList = this.detailList2;
        this.getCombinationDetail(goodsId);
      } else {
        this.detailList = this.detailList1;
        this.getGoodsDetail(goodsId);
      }
      //  if(this.type == 1){
      //    this.getGoodsDetail()
      //    this.detailList = this.detailList1
      //    if(this.status == 1 ){
      //       this.detailList = this.detailList3
      //    }else if(this.status == 2){
      //      this.detailList = this.detailList4
      //    }

      //  }else{
      //    this.getCombinationDetail()
      //    this.detailList = this.detailList2
      //  }
    },
  },
  mounted() {
    let nowData = new Date().toLocaleDateString();
    let active = JSON.parse(localStorage.getItem("smActivity"));
    let time = nowData == localStorage.getItem("startTime");
    if (active && time) {
      this.showSm = true;
      return;
    } else {
      this.$api.POST_SECRETACTIVITY().then((res) => {
        if (res.data.opened) {
          let startDate = new Date().toLocaleDateString();
          // console.log(myDate.getTime());
          localStorage.setItem("smActivity", true);
          localStorage.setItem("activityId", res.data.special.id);
          localStorage.setItem("startTime", startDate);

          this.$refs.smAct.showdhtx = true;
        } else {
          localStorage.setItem("smActivity", false);
        }
      });
    }
  },
  methods: {
    //获取单品
    getGoodsDetail(gid) {
      this.type = 1;
      this.$api
        .GET_GOODSDETAIL({
          goodsId: gid || this.$route.query.goodsId,
        })
        .then((res) => {
          if (res.status) {
            //console.log(res.data.images)
            /* if(res.data.images.length==0){
               res.data.images = [{large:this.$defaultImg}]
             } */
            this.gooodsDetail = res.data;
            if (this.detailList1.length == 3) {
              this.detailList1.splice(-1, 1);
            }
            this.detailList1.push({ name: res.data.name });
            this.detailList3.push({ name: res.data.name });
            this.detailList4.push({ name: res.data.name });
            this.ANALYSISSAVE(res.data, 2);
            //  this.$store.commit("SET_CATEGORYID",res.data.categoryId)
          }
        });
    },
    //获取套餐
    getCombinationDetail(gid) {
      this.type = 2;
      this.$api
        .GET_COMBINATIONDETAIL({
          id: gid || this.$route.query.goodsId,
        })
        .then((res) => {
          if (res.status) {
            //  if(res.data.images.length==0){
            //    res.data.images = [{large:this.$defaultImg}]
            //  }
            this.gooodsDetail = res.data;
            if (this.detailList2.length == 3) {
              this.detailList2.splice(-1, 1);
            }
            this.detailList2.push({ name: res.data.name });
            // this.$store.commit("SET_CATEGORYID",res.data.categoryId)
          }
        });
    },
    ANALYSISSAVE(gooodsDetail, savetype) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodsId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let goodsName = gooodsDetail.name;
      let keyword = this.$route.query.keyword;
      let url;
      let title;
      let type;
      if (savetype == 1) {
        (title = "加入购物车"), (type = "cart");
      } else {
        (title = "访问商品"), (type = "detail");
      }
      url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`;

      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodsId,
          goodsName,
          keyword,
        })
        .then((res) => {})
        .catch((err) => console.log(err));
    },
  },
  created() {
    //console.log(this.$route,'-------------------route')
    this.type = this.$route.query.type; //商品类型   1单品  2套餐
    this.status = this.$route.query.status;
    this.id = this.$route.query.goodsId;

    if (this.type == 1) {
      this.getGoodsDetail();

      this.detailList = this.detailList1;
      if (this.status == 1) {
        this.detailList = this.detailList3;
      } else if (this.status == 2) {
        this.detailList = this.detailList4;
      }
    } else {
      this.getCombinationDetail();
      this.detailList = this.detailList2;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/main/detail/index.vue